import SubcategorySection from './SubcategorySection';

export default SubcategorySection;
